import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="row">
        <div className="col-lg-12">
          <div className="color-monoDull">
            <p data-testid="power-by" className="-0 fs-14 d-flex align-items-center justify-content-center"></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
